module.exports = __webpack_public_path__ + "static/rabbit1-669fb42dca3fe924224a95f59fa2234f.webp";